import moment from 'moment'

export const COPYRIGHT = ` Transport.md / Geotrans.md 1999-${moment().format('YYYY')}`

export const phone1 = "373 22 289812"
export const phone2 = "373 22 289816"
export const phone3 = "373 79 502250"
export const phone4 = "373 78 807022"
